export const CHANGE_ANSWER_ACTION = 'CHANGE_ANSWER_ACTION';
export const RESET_ANSWER_ACTION = 'RESET_ANSWER_ACTION';

export const changeAnswerAction = ({ id, chosen }) => ({
  type: CHANGE_ANSWER_ACTION, id, chosen
});

export const resetAnswerAction = () => ({
  type: RESET_ANSWER_ACTION,
});



// WEBPACK FOOTER //
// ./src/actions/question.js